module.exports = __webpack_public_path__ + "static/media/key-4.f7c2a34c.jpg";